import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icon/up-right-from-square.svg'


const _hoisted_1 = { class: "send-pre-request col-11 col-sm-8 col-md-6 col-lg-4 mx-auto mt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 仮申込みを受け付けました。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" メールが届きましたら、記載のURLからユーザ情報を登録してください。 ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("メールが届かない場合")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "迷惑メールフォルダに入っていないかご確認ください。"),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("入力したメールアドレスが間違っている場合があります。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("心当たりのアドレスを全て試してもメールが届かない場合は"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.futureinn.co.jp/fi_enquetes/1001401.html",
      class: "text-muted",
      target: "_blank"
    }, [
      /*#__PURE__*/_createTextVNode("お問い合わせ"),
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "external",
        alt: "新規ウインドウで開く",
        title: "新規ウインドウで開く"
      })
    ]),
    /*#__PURE__*/_createTextVNode("ください。")
  ])
], -1)

import IconCircleInfo from '@/components/ui/IconCircleInfo.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SendMailView',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", null, [
      _createElementVNode("strong", null, [
        _createVNode(IconCircleInfo),
        _hoisted_3
      ])
    ]),
    _hoisted_4
  ]))
}
}

})